export default __webpack_public_path__ + "static/media/fishGirl.14f63bbf.jpg";